"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isECPModel = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const isECPModel = (whatever) => {
    var _a;
    const possibleEcpModel = whatever;
    return Boolean((0, echain_shared_ts_utils_1.isDefinedObject)(possibleEcpModel) &&
        possibleEcpModel.ArticleType === echain_product_models_1.ArticleType.zubehoer &&
        ((_a = possibleEcpModel.smartPlasticsType) === null || _a === void 0 ? void 0 : _a.includes(echain_prisma_client_1.SmartPlasticsType.ECP)));
};
exports.isECPModel = isECPModel;
//# sourceMappingURL=EcpModel.js.map